import { Zap, Shield, Globe, Coins, Workflow, Lock } from 'lucide-react'

const features = [
  {
    icon: Zap,
    title: 'Instant Payments',
    description: 'Pay for APIs in real-time with TCH tokens. No waiting, no delays.',
    label: 'SPEED',
  },
  {
    icon: Shield,
    title: 'Secure by Design',
    description: 'Private keys stored locally. mppx SDK handles payment on your machine only.',
    label: 'SECURITY',
  },
  {
    icon: Globe,
    title: 'Global Access',
    description: 'Works with any MCP client: Claude, Cursor, ZCode, and more.',
    label: 'COMPATIBILITY',
  },
  {
    icon: Coins,
    title: 'Pay Per Call',
    description: 'Only pay for what you use. Fractions of a cent to a few cents per call.',
    label: 'PRICING',
  },
  {
    icon: Workflow,
    title: 'MCP Native',
    description: 'Built on Model Context Protocol. Seamless integration with AI agents.',
    label: 'PROTOCOL',
  },
  {
    icon: Lock,
    title: 'No API Keys',
    description: 'No registration required. No API keys to manage. Just connect and pay.',
    label: 'SIMPLICITY',
  },
]

export function Features() {
  return (
    <section className="py-24 md:py-32 bg-foreground/2">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-sentient mb-8">
            Why Choose <span className="text-primary italic">tchmpp</span>?
          </h2>
          <p className="text-lg text-foreground/60 leading-relaxed">
            Built for the age of AI agents. tchmpp enables seamless machine-to-machine
            payments on ThaiChain, making it easy for agents to access paid APIs
            automatically.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative border border-foreground/10 rounded-lg p-6 hover:border-primary/50 transition-all duration-300 hover:shadow-lg hover:shadow-primary/10"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary group-hover:scale-110 transition-transform">
                  <feature.icon className="w-6 h-6" />
                </div>
                <div className="flex-1">
                  <span className="font-mono text-xs text-foreground/40 uppercase tracking-wider block mb-2">
                    {feature.label}
                  </span>
                  <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                  <p className="text-sm text-foreground/60 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
